export const formatNorwegianDate = (dateString?: string): string | undefined => {
  if (!dateString) return undefined;

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return undefined;

  return date
    .toLocaleDateString('nb-NO', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
    .replace(/\//g, '.');
};

export const formatDocNumber = (doc: string): string => {
  return doc.length >= 3 ? `${doc.slice(0, 3)}.${doc.slice(3)}` : doc;
};

export const sanitizeHtml = (html: string, numChars: number = 230): string => {
  const sanitizer = new DOMParser().parseFromString(html, 'text/html');
  let sanitizedVersion = sanitizer.body.textContent ?? '';
  sanitizedVersion = sanitizedVersion.replace(/<(?:a\b[^>]*>.*?<\/a|p|\/p|h[23]|\/h[23]|br\/|img\b[^>]*)>/gi, '');
  if (sanitizedVersion.length > numChars) {
    sanitizedVersion = sanitizedVersion.substring(0, numChars);
    const paraIndex = sanitizedVersion.indexOf('<p');
    if (paraIndex > 0) {
      sanitizedVersion = sanitizedVersion.substring(0, paraIndex);
    }
  }
  return sanitizedVersion;
};
